import React, { createContext, useContext, useState } from "react";

// Create the context
const ShowErrorDiaglogContext = createContext();

// Create a provider component
export const ShowErrorDiaglogProvider = ({ children }) => {
  const [showErrorDialog, setShowErrorDialogb] = useState(false);
  const [headerText, setHeaderText] = useState("");

  const openOrCloseErrorDialog = (value) => {
    setShowErrorDialogb(value);
  };
  const updateHeaderText = (text) => {
    setHeaderText(text);
  };

  return (
    <ShowErrorDiaglogContext.Provider
      value={{
        showErrorDialog,
        headerText,
        openOrCloseErrorDialog,
        updateHeaderText,
      }}
    >
      {children}
    </ShowErrorDiaglogContext.Provider>
  );
};

export const useShowErrorDiaglog = () => useContext(ShowErrorDiaglogContext);
